module.exports = __webpack_public_path__ + "static/1-82032883493e269cf55d6a0e83276a16.jpg";